import { CHANGE_LANGUAGE } from '../types/Language'

//******* SUCESSS **//
export const ChangeLanguage = languageID => {
  return {
    type: CHANGE_LANGUAGE,
    payload: languageID
  }
}
